export const PREDEFINED_QA = {
  "Can I use my bus pass as ID?":
    "That document isn't accepted for legal ID checks. Please upload a valid passport, UK photocard driving licence, or national ID card.",

  "I don't have a passport or driving licence. What can I do?":
    "If you don't have one of the accepted documents, please contact your legal representative. They'll advise on alternative methods or arrange an in-branch verification.",

  "My ID has expired. Can I still use it?":
    "Unfortunately, expired documents cannot be accepted for legal ID checks. Please upload a valid, in-date passport, UK photocard driving licence, or national ID card.",

  "What counts as proof of address?":
    "If requested, you can upload a utility bill, bank statement, council tax letter, or HMRC notice dated within the last 3 months.",

  "Why am I being asked for Source of Funds?":
    "For certain transactions (like buying or remortgaging a property), we must confirm how the funds are being provided — e.g., savings, sale of property, gift from family. This helps protect against money laundering and is required by law.",

  "I've been asked to upload a document again — why?":
    "This usually happens when the image is blurry, has glare, or is missing part of the document. Please try again in good lighting and ensure all edges are visible.",

  "What happens if I can't complete the check right now?":
    "No problem. You can save your progress and we'll send you a secure link so you can return and complete it later.",
};

// 🔥 IMPORTANT: Update your suggestedTopics array to match these EXACT keys
export const suggestedTopics = [
  "Can I use my bus pass as ID?",
  "I don't have a passport or driving licence. What can I do?",
  "My ID has expired. Can I still use it?",
  "What counts as proof of address?",
  "Why am I being asked for Source of Funds?",
  "I've been asked to upload a document again — why?",
  "What happens if I can't complete the check right now?",
];
